const HEADER_MAP = {
    name: ['name', 'beneficiary name', 'beneficiary_name'],
    mobile: ['mobile', 'mobile no', 'mobile number', 'phone', 'phone no'],
    email: ['email', 'email id', 'e-mail', 'emailid'],
    address: ['address', 'city', 'district'],
    ifsc: ['ifsc', 'ifsc code', 'ifsc_code'],
    account_no: ['account no', 'account number', 'account_no', 'a/c no', 'ac no', 'accountno'],
    gross_amount: ['gross amount', 'gross_amount', 'gross'],
    deduction_amount: ['deduction amount', 'deduction_amount', 'deduction'],
    net_amount: ['net amount', 'net_amount', 'net'],
};

const normalizeKey = (key) =>
    String(key || '')
        .replace(/\u00a0/g, ' ')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');

const pickField = (row, aliases) => {
    for (const [key, value] of Object.entries(row || {})) {
        if (!aliases.includes(normalizeKey(key))) continue;
        if (value == null || value === '') return '';
        return typeof value === 'string' ? value.trim() : value;
    }
    return '';
};

/**
 * Parse beneficiary reimbursement Excel rows.
 * Email / Mobile / Address are optional — Name, IFSC, Account No, Gross Amount are required.
 */
export const parseReimbursementExcelRows = (rows = [], createdBy = '') => {
    const beneficiaries = [];
    let gross = 0;
    let deduction = 0;
    let net = 0;

    rows.forEach((raw) => {
        const name = String(pickField(raw, HEADER_MAP.name) || '').trim();
        const ifsc = String(pickField(raw, HEADER_MAP.ifsc) || '').trim();
        const account_no = String(pickField(raw, HEADER_MAP.account_no) || '').trim();
        const gross_amount = pickField(raw, HEADER_MAP.gross_amount);
        if (!name || !ifsc || !account_no || gross_amount === '' || gross_amount == null) {
            return;
        }

        const deduction_amount = pickField(raw, HEADER_MAP.deduction_amount);
        const net_amount = pickField(raw, HEADER_MAP.net_amount);
        const deductionValue = deduction_amount === '' ? 0 : deduction_amount;
        const netValue =
            net_amount === ''
                ? Number(gross_amount || 0) - Number(deductionValue || 0)
                : net_amount;

        const row = {
            name,
            mobile: String(pickField(raw, HEADER_MAP.mobile) || ''),
            email: String(pickField(raw, HEADER_MAP.email) || ''),
            address: String(pickField(raw, HEADER_MAP.address) || ''),
            ifsc,
            account_no,
            gross_amount,
            deduction_amount: deductionValue,
            net_amount: netValue,
            created_by: createdBy,
        };

        beneficiaries.push(row);
        gross += Number(row.gross_amount || 0);
        deduction += Number(row.deduction_amount || 0);
        net += Number(row.net_amount || 0);
    });

    return {
        beneficiaries,
        totals: { gross, deduction, net },
    };
};
